import script from "./DatabaseView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatabaseView.vue?vue&type=script&setup=true&lang=ts"

import "./DatabaseView.vue?vue&type=style&index=0&id=306bacd5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306bacd5"]])

export default __exports__